import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import StaticItem from "../../Components/StaticItem/StaticItem";
import classNames from 'classnames';
import { DESKTOP } from "../../Constants/platform";
import DependencyManager from "../../DependencyManager";
import { Icon } from 'panamera-react-ui';
var css = {
  "arrow": "oalp-3cehK",
  "arrowRight": "oalp-78Sgq",
  "arrowLeft": "oalp-1rA8B",
  "disable": "oalp-1OqcH",
  "customDots": "oalp-3DhU4"
};
import Slider from 'react-slick';
export var SliderArrow = function SliderArrow(_ref) {
  var _classNames;
  var onClick = _ref.onClick,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? '' : _ref$iconName,
    size = _ref.size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _a;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: classNames(css.arrow, className, (_classNames = {}, _defineProperty(_classNames, css[iconName], css[iconName]), _defineProperty(_classNames, css.disable, !!((_a = className === null || className === void 0 ? void 0 : className.includes) === null || _a === void 0 ? void 0 : _a.call(className, 'slick-disabled'))), _classNames)),
    "data-aut-id": "cf-slider-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: iconName,
    size: size
  }));
};
export var CfCarouselWidget = function CfCarouselWidget(_ref2) {
  var data = _ref2.data,
    name = _ref2.name,
    metadata = _ref2.metadata;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var _ref3 = metadata || {},
    style = _ref3.style;
  var customSettings = {
    dots: true,
    infinite: false,
    lazyLoad: 'ondemand',
    arrows: PanameraConstants.platform === DESKTOP,
    dotsClass: css.customDots,
    nextArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowRight",
      size: 20
    }),
    prevArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowLeft",
      size: 20
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Slider, Object.assign({}, customSettings), data.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "widget_".concat(name, "_item_").concat(idx)
    }, /*#__PURE__*/React.createElement("div", {
      id: "widget_".concat(name, "_item_").concat(idx),
      style: style
    }, /*#__PURE__*/React.createElement(StaticItem, {
      image: item.image,
      widgetName: name
    })));
  })));
};
export default /*#__PURE__*/React.memo(CfCarouselWidget);